const SharePointModalTitle = "Navigate away?";
const SharePointModalBody = "Click Continue to open the CDTS SharePoint in a new browser window. This action will not impact the active visit.";

export {
    SharePointModalTitle,
    SharePointModalBody
};
